import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import { scrollToId } from "../lib/scroll";

const LINKS = [
  { label: "Services", id: "services" },
  { label: "Fleet & Rates", id: "fleet" },
  { label: "The Owner", id: "owner" },
  { label: "Contact", id: "contact" },
];

export default function Navbar({ onBook }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setMenuOpen(false);
    setTimeout(() => scrollToId(id), menuOpen ? 60 : 0);
  };

  return (
    <>
      <header
        className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 border-b ${
          scrolled
            ? "bg-ink/70 backdrop-blur-xl border-white/10"
            : "bg-transparent border-transparent"
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-[72px] flex items-center justify-between">
          <button
            data-testid="nav-logo-btn"
            onClick={() => window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-3"
          >
            <Logo />
            <span className="font-display uppercase text-lg tracking-wide">
              Aircon <span className="text-signal">Travel</span>
            </span>
          </button>

          <nav className="hidden md:flex items-center gap-8">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-link-${l.id}`}
                onClick={() => go(l.id)}
                className="font-mono text-[11px] uppercase tracking-[0.22em] text-zinc-400 hover:text-signal transition-colors duration-200"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="navbar-book-btn"
              onClick={() => onBook()}
              className="bg-signal text-ink font-mono text-[11px] uppercase tracking-[0.22em] px-6 py-3 hover:bg-bone transition-colors duration-200"
            >
              Book Now
            </button>
          </nav>

          <button
            data-testid="nav-mobile-menu-btn"
            className="md:hidden text-bone"
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            {menuOpen ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </header>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            data-testid="nav-mobile-menu"
            initial={{ opacity: 0, y: -16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -16 }}
            transition={{ duration: 0.25 }}
            className="fixed inset-0 z-40 bg-ink/95 backdrop-blur-xl md:hidden flex flex-col justify-center px-8"
          >
            {LINKS.map((l, i) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                className="text-left font-display uppercase text-4xl py-4 border-b border-white/10 text-bone hover:text-signal transition-colors"
              >
                <span className="font-mono text-xs text-signal mr-4">0{i + 1}</span>
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-mobile-book-btn"
              onClick={() => { setMenuOpen(false); onBook(); }}
              className="mt-8 bg-signal text-ink font-display uppercase text-2xl px-8 py-4"
            >
              Book Now
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
